import $ from 'jquery';
import ScrollMagic from 'scrollmagic';

import BjzmParallax from './bjzm-parallax';
/*BjzmParallax.doTheJpShuffle*/

class BjzmLoadMorePosts {

	constructor(args) {
		this.clickEvents();
		// this.parallax = new BjzmParallax();
	}

	clickEvents() {

		$('.load-more-button').on('click', (e) => {
			e.preventDefault();
			var $button = $(e.currentTarget);
			var data = {
				'action': 'loadmore',
				'query': BJZM_DATA.posts, 
				'page' : BJZM_DATA.current_page
			};
			this.doAjax($button, data);
		});
		
	}

	doTheJpShuffle() {
		
		var controller = new ScrollMagic.Controller();

		function addVisibleClass(event) {
			$(event.target.triggerElement()).addClass('entered')
		}

		$(".jp-shuffle--news-card").each(function() {

			var scene = new ScrollMagic.Scene({
				triggerElement: this,
				triggerHook: 1,
				offset: 130
			})
			// .addIndicators()
			.on('start', addVisibleClass)
			.addTo(controller);		  
		});

	}

	doAjax($button, data) {

		$button.html('Loading...').addClass('button--disabled');
		var self = this;
		$.ajax({
			url : BJZM_DATA.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$button.text('Loading...'); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) { 

					$(".blog-post-loop").append(data);
					$button.text( 'Load More Posts' ).removeClass('button--disabled');
					BJZM_DATA.current_page++;

					// self.parallax.doTheJpShuffle();
					self.doTheJpShuffle();

					if ( BJZM_DATA.current_page == BJZM_DATA.max_page ) 
						$button.remove(); // if last page, remove the button

				} else {
					$button.remove(); // if no data, remove the button as well
				}
			}
		});
	}

	handleResponse(html) {

		this.loadMoreSection.remove();
		this.post_loop.append(html);
		var newLoadMoreSection = this.loadMoreSection.clone();
		
		if( this.page < this.max_num_pages ) {
			this.post_loop.append(this.loadMoreSection);
			$('.bjzm-match-height').matchHeight({
				byRow: false
			});
		}	

	}

}

module.exports = BjzmLoadMorePosts;